import { ConfigData, TimerType } from '@/types';

export const DISPLAY_AT = {
	HOME_PAGE: 'home',
	ALL_PAGES: 'all',
	SPECIFIC_PAGE: 'specific',
	CATEGORY: 'category',
	PRODUCT: 'product',
} as const;

export const DISPLAY_AT_OPTIONS = [
	{ value: DISPLAY_AT.HOME_PAGE, label: 'Home page' },
	{ value: DISPLAY_AT.ALL_PAGES, label: 'All pages' },
	{ value: DISPLAY_AT.SPECIFIC_PAGE, label: 'Specific page' },
	{ value: DISPLAY_AT.CATEGORY, label: 'Category pages' },
	{ value: DISPLAY_AT.PRODUCT, label: 'Product pages' },
];

/** A product container lives inside a product page: it targets products, or products of the selected categories. */
const PRODUCT_CONTAINER_DISPLAY_AT_OPTIONS = [
	{ value: DISPLAY_AT.PRODUCT, label: 'Product pages' },
	{ value: DISPLAY_AT.CATEGORY, label: 'Category pages' },
];

export function getDisplayAtOptions(timerType: TimerType) {
	return timerType === TimerType.PRODUCT_CONTAINER ? PRODUCT_CONTAINER_DISPLAY_AT_OPTIONS : DISPLAY_AT_OPTIONS;
}

export function isDisplayAtAvailable(timerType: TimerType, displayAt: string) {
	return getDisplayAtOptions(timerType).some((option) => option.value === displayAt);
}

export const EMPTY_DISPLAY_AT_TARGETING: Pick<ConfigData, 'categories' | 'specificPages' | 'products'> = {
	categories: [],
	specificPages: [],
	products: [],
};

/**
 * The config keeps only the collection of the chosen Display at — a collection left behind is dropped, so a saved
 * timer never carries a stale targeting.
 */
export function switchDisplayAt(config: ConfigData, displayAt: string): Partial<ConfigData> {
	if (!displayAt || displayAt === config.display_at) {
		return {};
	}

	return { display_at: displayAt, ...EMPTY_DISPLAY_AT_TARGETING };
}
